<div class="core-ui-input-time" [class.core-ui-input-time--block]="block"
    [class.core-ui-input-time--icon-left]="icon && iconPosition === 'left'"
    [class.core-ui-input-time--icon-right]="icon && iconPosition === 'right'" [class.is-open]="isOpen"
    [attr.data-size]="size">

    <div class="core-ui-input-time__control" cdkOverlayOrigin #origin="cdkOverlayOrigin" [class.is-filled]="isFilled"
        [class.is-disabled]="disabled" [class.is-readonly]="readOnly" [class.is-open]="isOpen"
        (click)="toggleDropdown()">
        <button type="button" class="core-ui-input-time__trigger" [disabled]="disabled"
            [attr.aria-disabled]="disabled" [attr.aria-readonly]="readOnly" [attr.aria-expanded]="isOpen">

            <div class="core-ui-input-time__input-wrapper">

                <ng-container *ngIf="icon && iconPosition === 'left'">
                    <div class="core-ui-input-time__icon-left">
                        <core-ui-icon [size]="sizeIcon" [name]="icon" [color]="iconColor"></core-ui-icon>
                    </div>
                </ng-container>

                <div class="core-ui-input-time__search-input-text">
                    <span *ngIf="label" class="core-ui-input-time__label">{{ label }}</span>

                    <span class="core-ui-input-time__value" [class.is-placeholder]="!value"
                        [class.is-filled-text]="isFilled">
                        {{ displayValue }}
                    </span>
                </div>

                <ng-container *ngIf="icon && iconPosition === 'right'">
                    <div class="core-ui-input-time__icon-right">
                        <core-ui-icon [size]="sizeIcon" [name]="icon" [color]="iconColor"></core-ui-icon>
                    </div>
                </ng-container>

            </div>
        </button>

        <div class="core-ui-input-time__actions">
            <button *ngIf="showClearButton" type="button" class="core-ui-input-time__clear"
                aria-label="Limpiar hora"
                (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                (click)="clearValue($event)">
                <core-ui-icon name="icon_close" size="12"></core-ui-icon>
            </button>

            <div class="core-ui-input-time__chevron">
                <core-ui-icon name="chevron" [direction]="isOpen ? 'up' : 'down'"
                    [color]="'#5F7081'"></core-ui-icon>
            </div>
        </div>

        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origin" [cdkConnectedOverlayOpen]="isOpen"
            [cdkConnectedOverlayHasBackdrop]="false" [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
            [cdkConnectedOverlayPositions]="positions" [cdkConnectedOverlayPush]="true"
            [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayViewportMargin]="8"
            [cdkConnectedOverlayWidth]="overlayWidth" (attach)="onOverlayAttach()"
            (detach)="onOverlayDetach()">
            <div class="core-ui-input-time__dropdown" #panelEl (mousedown)="onPanelMouseDown()">
                <div class="core-ui-input-time__preview">
                    {{ previewValue }}
                </div>

                <div class="core-ui-input-time__columns">
                    <div class="core-ui-input-time__column">
                        <span class="core-ui-input-time__column-label">HH</span>

                        <div class="core-ui-input-time__list">
                            <button type="button" class="core-ui-input-time__item" *ngFor="let h of hours"
                                [class.core-ui-input-time__item--active]="h === selectedHour"
                                [class.core-ui-input-time__item--disabled]="isHourDisabled(h)"
                                [disabled]="isHourDisabled(h)"
                                (click)="onSelectHour(h)">
                                {{ h < 10 ? '0' + h : h }} </button>
                        </div>
                    </div>

                    <div class="core-ui-input-time__column">
                        <span class="core-ui-input-time__column-label">MM</span>

                        <div class="core-ui-input-time__list">
                            <button type="button" class="core-ui-input-time__item" *ngFor="let m of minutes"
                                [class.core-ui-input-time__item--active]="m === selectedMinute"
                                [class.core-ui-input-time__item--disabled]="isMinuteDisabled(m)"
                                [disabled]="isMinuteDisabled(m)"
                                (click)="onSelectMinute(m)">
                                {{ m < 10 ? ('0' + m) : m }} </button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

    </div>
</div>
